var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudioIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1566 15.6587C26.1566 14.7267 25.415 13.9712 24.5003 13.9712C23.5856 13.9712 22.8441 14.7267 22.8441 15.6587V33.6587C22.8441 34.5907 23.5856 35.3462 24.5003 35.3462C25.415 35.3462 26.1566 34.5907 26.1566 33.6587V15.6587Z",
    fill: "#D6D9DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5316 17.9087C19.5316 16.9767 18.79 16.2212 17.8753 16.2212C16.9606 16.2212 16.2191 16.9767 16.2191 17.9087L16.2191 31.4087C16.2191 32.3407 16.9606 33.0962 17.8753 33.0962C18.79 33.0962 19.5316 32.3407 19.5316 31.4087V17.9087Z",
    fill: "#D6D9DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7816 17.9087C32.7816 16.9767 32.04 16.2212 31.1253 16.2212C30.2106 16.2212 29.4691 16.9767 29.4691 17.9087V31.4087C29.4691 32.3407 30.2106 33.0962 31.1253 33.0962C32.04 33.0962 32.7816 32.3407 32.7816 31.4087V17.9087Z",
    fill: "#D6D9DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9066 22.4087C12.9066 21.4767 12.165 20.7212 11.2503 20.7212C10.3356 20.7212 9.59408 21.4767 9.59408 22.4087V26.9087C9.59408 27.8407 10.3356 28.5962 11.2503 28.5962C12.165 28.5962 12.9066 27.8407 12.9066 26.9087V22.4087Z",
    fill: "#D6D9DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4066 22.4087C39.4066 21.4767 38.665 20.7212 37.7503 20.7212C36.8356 20.7212 36.0941 21.4767 36.0941 22.4087V26.9087C36.0941 27.8407 36.8356 28.5962 37.7503 28.5962C38.665 28.5962 39.4066 27.8407 39.4066 26.9087V22.4087Z",
    fill: "#D6D9DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5003 0.471191C11.3893 0.471191 0.760742 11.3003 0.760742 24.6587C0.760742 38.0171 11.3893 48.8462 24.5003 48.8462C37.6113 48.8462 48.2399 38.0171 48.2399 24.6587C48.2399 11.3003 37.6113 0.471191 24.5003 0.471191ZM4.07324 24.6587C4.07324 13.1643 13.2188 3.84619 24.5003 3.84619C35.7819 3.84619 44.9274 13.1643 44.9274 24.6587C44.9274 36.1531 35.7819 45.4712 24.5003 45.4712C13.2188 45.4712 4.07324 36.1531 4.07324 24.6587Z",
    fill: "#D6D9DC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audioIcon.164c89833f30426d58c1958ff7528b7c.svg";
export { ForwardRef as ReactComponent };